module.exports = __webpack_public_path__ + "img/bg.cebf5434.png";